// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_page__35nw1 {
  padding: 12px 16px 100px 16px;
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
  background: rgb(247, 246, 255);
  text-align: center;
  color: rgb(255, 255, 255);
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}
.style_page__title__5phnU {
  font-size: 26px;
  font-weight: bold;
  color: rgb(27, 27, 27);
  position: relative;
}
.style_page__title__white__QWEl1 {
  color: rgb(255, 255, 255);
}

.style_description__g2dGm {
  color: rgb(135, 135, 135);
  font-size: 1.4rem;
  line-height: 17px;
  font-weight: 500;
  text-align: center;
  max-width: 343px;
}

.style_clans__ZdbtR {
  display: flex;
  flex-direction: column;
  gap: 12px;
  color: rgb(27, 27, 27);
  width: 100%;
}

.style_popover__image__nVpUv {
  margin-top: 32px;
  width: 120px;
  height: 120px;
}
.style_popover__image__nVpUv img {
  width: 100%;
  height: 100%;
}

.style_popover__actions__sRs-q {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  margin-top: 24px;
}

.style_popover__text__limitation__s3DsQ {
  max-width: 280px;
}`, "",{"version":3,"sources":["webpack://./src/features/clans/clan-selection/style.module.scss","webpack://./public/assets/colors.scss"],"names":[],"mappings":"AAEA;EACE,6BAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,8BAAA;EACA,kBAAA;EACA,yBCJM;EDKN,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AADF;AAGE;EACE,eAAA;EACA,iBAAA;EACA,sBCjBU;EDkBV,kBAAA;AADJ;AAGI;EACE,yBClBE;ADiBR;;AAMA;EACE,yBC1BU;ED2BV,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,sBCvCY;EDwCZ,WAAA;AAHF;;AAMA;EACE,gBAAA;EACA,YAAA;EACA,aAAA;AAHF;AAIE;EACE,WAAA;EACA,YAAA;AAFJ;;AAMA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;AAHF;;AAMA;EACE,gBAAA;AAHF","sourcesContent":["@import '../../../../public/assets/colors';\n\n.page {\n  padding: 12px 16px 100px 16px;\n  width: 100vw;\n  height: 100vh;\n  overflow-y: auto;\n  background: rgba(247, 246, 255, 1);\n  text-align: center;\n  color: $white;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n\n  &__title {\n    font-size: 26px;\n    font-weight: bold;\n    color: $black-extra;\n    position: relative;\n\n    &__white {\n      color: $white;\n    }\n  }\n}\n\n.description {\n  color: $dark-grey;\n  font-size: 1.4rem;\n  line-height: 17px;\n  font-weight: 500;\n  text-align: center;\n  max-width: 343px;\n}\n\n.clans {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  color: $black-extra;\n  width: 100%;\n}\n\n.popover__image {\n  margin-top: 32px;\n  width: 120px;\n  height: 120px;\n  img {\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.popover__actions {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  width: 100%;\n  margin-top: 24px;\n}\n\n.popover__text__limitation {\n  max-width: 280px;\n}\n","$main: rgba(117, 83, 240, 1);\n$light-main: rgba(237, 235, 254, 1);\n$black-extra: rgba(27, 27, 27, 1);\n$dark-grey: rgba(135, 135, 135, 1);\n$light-background: rgba(247, 246, 255, 1);\n$white: rgba(255, 255, 255, 1);\n$light-grey: rgba(213, 212, 220, 1);\n$yellow: rgba(255, 199, 1, 1);\n$grey: rgba(158, 158, 158, 1);\n$light-green: #39b283;\n$green: #1f6b4e;\n$dark-green: #1f4c3a;\n$danger: #c10000;\n$red: #e73232;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `style_page__35nw1`,
	"page__title": `style_page__title__5phnU`,
	"page__title__white": `style_page__title__white__QWEl1`,
	"description": `style_description__g2dGm`,
	"clans": `style_clans__ZdbtR`,
	"popover__image": `style_popover__image__nVpUv`,
	"popover__actions": `style_popover__actions__sRs-q`,
	"popover__text__limitation": `style_popover__text__limitation__s3DsQ`
};
export default ___CSS_LOADER_EXPORT___;
